export const jarvisPrimeInvestMoreConstants = {
    PRIME_INVESTMENT_PRICING_DETAILS_API: "v1/investment/additional-investment-fees",
    SUBMIT_PRIME_INVEST_MORE_API: "prime/investment/submit-invest-more",
    PRIME_INVESTMENT_STOCKS_REQUEST: "PRIME_INVESTMENT_STOCKS_REQUEST",
    PRIME_INVESTMENT_STOCKS_RESPONSE: "PRIME_INVESTMENT_STOCKS_RESPONSE",
    PRIME_INVESTMENT_STOCKS_SAGA: "PRIME_INVESTMENT_STOCKS_SAGA",
    PRIME_INVESTMENT_STOCKS_API: "prime/investment/additional-investment/stocks",
    RESET_PRIME_INVEST_MORE_DATA: "RESET_PRIME_INVEST_MORE_DATA"
};
  